// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    isAuthenticatedConsignee: false,
    isRootUser: false,
    consignee: {
      name: "",
      email: "",
      userNo: "",
      companyNo: "",
      company: ""
    },
    consigneeToken: "",
    currencyData: null,
    baseCurrencyId: 0,
    baseCurrency: '',
    currency: "GBP"
  },

  reducers: {
    handleConsigneeLogin: (state, action) => {
      state.isAuthenticatedConsignee = true
      state.consigneeToken = action.payload.token
      axios.defaults.headers.common["Authorization"] = `Bearer ${action.payload.token}`
      state.isRootUser = action.payload.companyNo === 0
      state.consignee = {
        name: action.payload.name,
        email: action.payload.email,
        userNo: action.payload.userNo,
        companyNo: action.payload.companyNo,
        company: action.payload.company,
        permissions: action.payload.permissions
      }
    },
    handleConsigneeLogout: (state) => {
      state.isAuthenticatedConsignee = false
      state.consigneeToken = ""
      state.consignee = {
        name: "",
        email: "",
        userNo: "",
        companyNo: "",
        company: ""

      }
    },
    setCompany: (state, action) => {
      state.consignee.companyNo = action.payload.companyNo
      state.consignee.company = action.payload.company
    },
    handleLogout: (state, action) => {
      state.skin = action.payload
      window.localStorage.setItem("skin", JSON.stringify(action.payload))
    },
    handleCurrency: (state, action) => {
      state.currencyData = action.payload.data
      state.baseCurrencyId = action.payload.baseCurrencyId
      state.baseCurrencySymbol = action.payload.baseCurrencySymbol
      state.baseCurrency = action.payload.base
    }
  }
})

export const {
  handleConsigneeLogin,
  handleConsigneeLogout,
  handleLogout,
  setCompany,
  handleCurrency
} = authSlice.actions

export default authSlice.reducer
